import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DelayHoursField } from "@/ui/Inputs/DelayHoursField";
import { SystemDropdown } from "@/ui/Inputs/SystemDropDown";
import { MIN_AGENCY_POST_DELAY_HOURS } from "@/utils/agencyPostDelay";

export function AgencyTimingFields({
	timing,
	hours,
	onChange,
	dataTestId,
	disabled,
}: {
	timing: "now" | "before";
	hours: string;
	onChange: (timing: "now" | "before", hours: string) => void;
	dataTestId: string;
	disabled?: boolean;
}) {
	const { t } = useTranslation();
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
			<SystemDropdown<"now" | "before">
				label={t("agency.multi.timing")}
				selectedItem={timing}
				items={[
					{ value: "now", label: t("agency.multi.now") },
					{ value: "before", label: t("agency.multi.before") },
				]}
				onChange={(value) => {
					if (value) onChange(value, hours);
				}}
				fullWidth
				disabled={disabled}
				data-testid={`${dataTestId}-timing`}
			/>
			{timing === "before" && (
				<>
					<DelayHoursField
						value={hours}
						onChange={(value) => onChange(timing, value)}
						suffixLabel={t("hours.before.shift.start")}
						minHours={MIN_AGENCY_POST_DELAY_HOURS}
						invalidHelperText={t("agency.post.delay.invalid", { min: MIN_AGENCY_POST_DELAY_HOURS })}
						dataTestId={`${dataTestId}-hours`}
						disabled={disabled}
					/>
					<Typography variant="caption" color="text.secondary">
						{t("agency.multi.timing.example")}
					</Typography>
				</>
			)}
		</Box>
	);
}
